import { useBreadcrumb } from "features/breadcrumbs"; 
import HeaderTable from "components/Page/HeaderTable";
import { useState, useRef } from "react";
import { useLoading } from "components/GlobalLoading";
import { showErrorAxios, showSuccess, showConfirm } from "infra/helpers/alerta";
import PageHeader from "components/Page/PageHeader";
import history from "infra/helpers/history";
import useDeleteRetornoBancario from "features/retorno-bancario/hooks/useDeleteRetornoBancario";
import useRetornosBancarios from "features/retorno-bancario/hooks/useRetornosBancarios";
import useImportRetornoBancario from "features/retorno-bancario/hooks/useImportRetornoBancario";
import SelectMonthYear from "components/Input/SelectMonthYear";
import NewTable from "components/NewTable";
import Resumo from "./components/ResumoHoje/Resumo";
import useRetornoBancarioColumns from "./components/useRetornoBancarioColumns";
import moment from "moment";
import { PermissaoEnum } from "core/resources/enums/permissao";
import { checkPermission } from "infra/helpers/permission";
import Container from "components/Container";

function ConciliacaoBancariaPages() {
  const inputFile = useRef<HTMLInputElement>(null);

  const [search, setSearch] = useState<string>("");
  const [page, setPage] = useState<number>(1);

  const [selectedDate, setSelectedDate] = useState(moment());

  const { isFetching, data, refetch } = useRetornosBancarios({
    search,
    page,
    dataInicio: selectedDate.startOf("month").format("YYYY-MM-DD"),
    dataFim: selectedDate.endOf("month").format("YYYY-MM-DD"),
  });

  const { isLoading: isLoadingDelete, mutate: handleDelete } =
    useDeleteRetornoBancario();

  const { mutate: handleImport, isLoading: isLoadingImport } =
    useImportRetornoBancario();

  const columns = useRetornoBancarioColumns();

  useLoading(isLoadingDelete || isLoadingImport);

  useBreadcrumb([
    { name: "Financeiro" },
    { name: "Retorno Bancário" },
  ]);

  return (
    <Container>
      <input
        type="file"
        id="file"
        ref={inputFile}
        style={{ display: "none" }}
      />
      <PageHeader
        onClick={() => {
          inputFile.current?.click();
          inputFile.current?.addEventListener("change", (ev) => {
            handleImport((ev.target as any).files, {
              onSuccess: () => {
                showSuccess("Importação realizada com sucesso!");
                refetch();
              },
            });
          });
        }}
        title="Retorno Bancário"
        titleButton={
          checkPermission(
            PermissaoEnum.Backoffice.Financeiro.RetornoBancario.ProcessarArquivo
          )
            ? "Processar Arquivos"
            : undefined
        }
        midComponent={
          <>
            <SelectMonthYear
              bg="white"
              value={selectedDate}
              onChange={(date) => date && setSelectedDate(date)}
            />
          </>
        }
      />

      <Resumo selectedDate={selectedDate} />

      <NewTable
        title={() => (
          <HeaderTable
            value={search}
            onSearch={(q?: string) => setSearch(q!)}
          />
        )}
        loading={isFetching}
        columns={columns}
        dataSource={data?.items ?? []}
        onRow={(v) => ({
          style: {
            cursor: "pointer",
          },
          onClick: () => {
            history.push(
              `/financeiro/retorno-bancario/${selectedDate
                .startOf("month")
                .format("YYYY-MM-DD")}/${selectedDate
                .endOf("month")
                .format("YYYY-MM-DD")}/${v.id}`
            );
          },
        })}
        actions={[
          {
            title: "Excluir",
            onClick: (v) =>
              showConfirm().then(({ isConfirmed }) => {
                if (isConfirmed) {
                  handleDelete(v.id, {
                    onSuccess: () => {
                      showSuccess().then(() => refetch());
                    },
                    onError: (err) => {
                      showErrorAxios(err);
                    },
                  });
                }
              }),
          },
        ]}
        customPagination={{
          currentPage: data?.meta.currentPage ?? 0,
          totalItems: data?.meta.totalItems ?? 0,
          itemsPerPage: data?.meta.itemsPerPage ?? 0,
          onChangePage: (p) => setPage(p),
        }}
        scroll={{ x: true }}
      />
    </Container>
  );
}

export default ConciliacaoBancariaPages;
